import { render, staticRenderFns } from "./UserDocuments.vue?vue&type=template&id=7a602eec&scoped=true&"
import script from "./UserDocuments.vue?vue&type=script&lang=js&"
export * from "./UserDocuments.vue?vue&type=script&lang=js&"
import style0 from "./UserDocuments.vue?vue&type=style&index=0&id=7a602eec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a602eec",
  null
  
)

export default component.exports